import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import {ApiCode} from "@/const/api";

export default {
    async getCertificateImplement(params) {
        try {
            const response = await axios.get('certificates/certificate_implements', { params })
            const { data } = response
            if (data.code === ApiCode.SUCCESS) {
                const { total, records } = data.data
                return records
            }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
}
